// Mock data for Perrin Myddelton Solicitors
// All content sourced from pmsolicitors.co.uk, styled after Hedges Law brand guidelines

export const brand = {
  name: 'Perrin Myddelton',
  shortName: 'Perrin Myddelton',
  tagline: 'Expertise with Care',
  established: 'Trusted Solicitors in Harpenden',
  logoUrl: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_hedgeslaw-pmsol/artifacts/ieboc79r_image.png',
  contactEmail: 'john.hotham@hedgeslaw.co.uk',
  publicEmail: 's.atkins@pmsolicitors.co.uk',
  phone: '01582 466140',
  fax: '01582 766140',
  address: {
    line1: '10 Waterside',
    line2: 'Station Road',
    city: 'Harpenden',
    postcode: 'AL5 4US'
  }
};

export const nav = [
  { label: 'Our People', href: '/our-people' },
  { label: 'About', href: '/about' },
  { label: 'Services', href: '/services' },
  { label: 'Case Studies', href: '/case-studies' },
  { label: 'Pricing', href: '/pricing' },
  { label: 'Insights', href: '/insights' },
  { label: 'Contact Us', href: '/contact' }
];

export const hero = {
  eyebrow: 'Expertise with Care',
  title: 'Trusted Solicitors Serving Clients for Over 20 Years',
  intro: 'At Perrin Myddelton, we pride ourselves on having provided high quality legal services to commercial, public sector and private clients for 20 years.',
  ctaLabel: "Let's have a chat",
  ctaHref: '/contact',
  image: 'https://images.unsplash.com/photo-1521587760476-6c12a4b040da?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHw0fHxsYXclMjBvZmZpY2V8ZW58MHx8fHwxNzg1OTY3NjA3fDA&ixlib=rb-4.1.0&q=85'
};

export const heartSection = {
  title: 'The Heart of Perrin Myddelton',
  body: 'Perrin Myddelton is a well-established law firm based in Harpenden, Hertfordshire, just outside London. Our team of solicitors combine strong technical expertise with a practical, client-focused approach. We understand that clients need a firm that is approachable, accessible and responsive. Building strong working relationships and delivering clear, straightforward advice is a critical part of the value we provide.',
  image: 'https://images.unsplash.com/photo-1638057733961-591fa542f718?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxFbmdsaXNoJTIwY291bnRyeXNpZGV8ZW58MHx8fHwxNzg1OTY3NjA3fDA&ixlib=rb-4.1.0&q=85'
};

export const services = [
  {
    slug: 'commercial-property',
    name: 'Commercial Property',
    tagline: 'Buying, selling, leasing and development of commercial premises.',
    image: 'https://images.unsplash.com/photo-1497366811353-6870744d04b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2V8ZW58MHx8fHwxNzg1OTY3NjA3fDA&ixlib=rb-4.1.0&q=85',
    intro: 'Our Commercial Property team advises landlords, tenants, developers, investors and lenders across a wide range of commercial real estate transactions. We combine sharp technical knowledge with commercial pragmatism to deliver deals that meet your objectives on time.',
    highlights: [
      'Acquisitions and disposals of freehold and leasehold interests',
      'Landlord and tenant advice, including lease renewals and dilapidations',
      'Secured lending and refinancing',
      'Portfolio management and asset transfers',
      'Auction sales and purchases'
    ]
  },
  {
    slug: 'company-commercial',
    name: 'Company Commercial',
    tagline: 'Practical advice for businesses at every stage of their journey.',
    image: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxsYXclMjBvZmZpY2V8ZW58MHx8fHwxNzg1OTY3NjA3fDA&ixlib=rb-4.1.0&q=85',
    intro: 'From incorporation and shareholder agreements through to sales, acquisitions and everyday commercial contracts, our Company Commercial team gives clear, straightforward advice tailored to the needs of owner-managed businesses and larger corporates alike.',
    highlights: [
      'Company formation and shareholder agreements',
      'Sales, acquisitions and management buy-outs',
      'Commercial contracts and terms of business',
      'Joint ventures and partnerships',
      'Corporate governance and reorganisations'
    ]
  },
  {
    slug: 'dispute-resolution',
    name: 'Dispute Resolution',
    tagline: 'Resolving disputes swiftly, sensibly and commercially.',
    image: 'https://images.unsplash.com/photo-1593115057322-e94b77572f20?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBsZWdhbHxlbnwwfHx8fDE3ODU5Njc2MDd8MA&ixlib=rb-4.1.0&q=85',
    intro: 'Our dispute resolution solicitors are experienced litigators who focus on achieving the best possible outcome, whether through negotiation, mediation or court proceedings. We take the time to understand the commercial context of every dispute.',
    highlights: [
      'Contractual and commercial disputes',
      'Property and landlord & tenant disputes',
      'Debt recovery and enforcement',
      'Professional negligence claims',
      'Alternative dispute resolution and mediation'
    ]
  },
  {
    slug: 'property-development',
    name: 'Property Development',
    tagline: 'Supporting developers from site acquisition to plot sales.',
    image: 'https://images.unsplash.com/photo-1657978837950-03646a7c7b9e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBvZmZpY2V8ZW58MHx8fHwxNzg1OTY3NjA3fDA&ixlib=rb-4.1.0&q=85',
    intro: 'We act for national housebuilders, regional developers and land promoters on the full lifecycle of a development. Our team brings a proactive, delivery-focused approach to every scheme.',
    highlights: [
      'Site acquisition and option agreements',
      'Planning and infrastructure agreements',
      'Development finance',
      'Estate set-up and plot sales',
      'Overage and clawback advice'
    ]
  },
  {
    slug: 'residential-conveyancing',
    name: 'Residential Conveyancing',
    tagline: 'Moving home made straightforward.',
    image: 'https://images.unsplash.com/photo-1672380135241-c024f7fbfa13?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxzb2xpY2l0b3IlMjBoYW5kc2hha2V8ZW58MHx8fHwxNzg1OTY3NjA3fDA&ixlib=rb-4.1.0&q=85',
    intro: 'Our residential conveyancing team makes buying, selling or remortgaging your home as smooth as possible. We are accredited under the Law Society Conveyancing Quality Scheme and pride ourselves on responsive, personal service.',
    highlights: [
      'Freehold and leasehold sales and purchases',
      'Remortgages and transfers of equity',
      'New-build purchases',
      'Help to Buy, Shared Ownership and Right to Buy',
      'Lease extensions'
    ]
  },
  {
    slug: 'social-housing',
    name: 'Social Housing',
    tagline: 'Grade 1 ranked advisors to Housing Associations.',
    image: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwzfHxzb2xpY2l0b3IlMjBoYW5kc2hha2V8ZW58MHx8fHwxNzg1OTY3NjA3fDA&ixlib=rb-4.1.0&q=85',
    intro: 'We are recognised as a Grade 1 firm in the Thames Valley region for social housing by Chambers and Partners. We act for over 40 of the largest Housing Associations across a full range of contentious and non-contentious matters.',
    highlights: [
      'Development and stock rationalisation',
      'Landlord and tenant / housing management',
      'Anti-social behaviour and possession',
      'Regulatory and governance advice',
      'Shared ownership and staircasing'
    ]
  },
  {
    slug: 'family-law',
    name: 'Family Law',
    tagline: 'Pragmatic, sensitive advice at life\u2019s most difficult moments.',
    image: 'https://images.unsplash.com/photo-1511895426328-dc8714191300?w=1200&q=80&auto=format&fit=crop',
    intro: 'Our family law solicitors support you with expert legal advice across the full range of family matters. From pre and post-nuptial agreements and family planning through to divorce, separation and disputes, we offer pragmatic advice while remaining sensitive to your needs. We work hard to help you retain clarity and ownership while navigating the complexities of family law.',
    highlights: [
      'Divorce, separation and financial settlements',
      'Pre and post-nuptial agreements',
      'Arrangements for children and child custody',
      'Cohabitation agreements and disputes',
      'Dissolution of civil partnerships',
      'Domestic abuse and protective orders',
      'One Couple, One Lawyer service for divorcing couples'
    ]
  },
  {
    slug: 'private-wealth',
    name: 'Private Wealth',
    tagline: 'Advice for life. Wills, probate, inheritance and later-life planning.',
    image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=1200&q=80&auto=format&fit=crop',
    intro: 'Advice for Life means supporting you with expert legal advice at every stage of your journey. Our private client team helps you create and update your Will, plan your estate to protect your assets, and advises on probate, trusts, lasting powers of attorney and any disputes that may arise, including what to do in the event of the death of a loved one.',
    highlights: [
      'Wills, including complex and business wills',
      'Probate and estate administration',
      'Inheritance and estate planning',
      'Lasting Powers of Attorney',
      'Court of Protection applications',
      'Inheritance tax advice',
      'Trusts and asset protection',
      'Contesting a will and inheritance disputes'
    ]
  },
  {
    slug: 'estate-agents',
    name: 'Estate Agents',
    tagline: 'Specialist legal support for estate, letting and managing agents.',
    image: 'https://images.pexels.com/photos/7937763/pexels-photo-7937763.jpeg?w=1200&auto=compress&cs=tinysrgb',
    intro: 'We advise Estate Agents, Letting Agents and Managing Agents on the full range of issues they face, from protecting their commission and their clientele through to lettings law and an increasingly complex regulatory landscape.',
    highlights: [
      'Commission disputes',
      'Franchising issues',
      'Restrictive covenants',
      'Landlord and tenant issues',
      'Consumer protection legislation and regulatory issues'
    ],
    related: ['social-housing', 'dispute-resolution'],
    sections: [
      { heading: 'Commission Disputes', body: 'We have a wealth of experience in dealing with commission disputes involving Estate Agents and their clients. Estate Agency contracts are governed, amongst other legislation, by the Estate Agents Act 1979 and the Estate Agents (Provision of Information) Regulations 1991. Whether the agreement is a sole agency, a multi-agency or a sole selling rights agency, we advise on the contractual position between the parties and the Agent\u2019s entitlement to its commission. Depending upon the wording of the agreement, sometimes the claim will be for the full amount of the agency fee and sometimes a claim in damages representing the loss of profit for the Agent or the loss of opportunity in obtaining a fee. We advise on all issues relating to commission and disputes and, where necessary, obtain injunctive relief to protect the Agent\u2019s fee. This normally entails seeking freezing orders to protect the commission until a court has determined the Agent\u2019s entitlement to a fee.' },
      { heading: 'Franchising Issues', body: 'Some Agents expand their business through franchising and we advise on all aspects of franchising, both for the franchisee and franchisor. These agreements are often detailed and complex and we provide expert advice on the rights and liabilities under such agreements. Where necessary, we are able to enforce the agreement against a party acting in breach of a franchise agreement.' },
      { heading: 'Restrictive Covenants', body: 'In the agency world, the poaching and solicitation of both clients and staff is not uncommon. We advise on all aspects of restrictive covenants and their enforceability. When breached, we act to protect the Agent\u2019s position in protecting the Agent\u2019s clientele, staff and sometimes data which may have been unlawfully copied or taken by a member of staff. Sometimes Agents set up in competition to their former employer and advice is given as to the enforceability of these covenants where appropriate.' },
      { heading: 'Landlord and Tenant Issues', body: 'Many Agents provide a lettings service and we provide detailed and comprehensive advice to our clients on the law relating to lettings. We deal with all types of tenancies and licenses and can advise on all aspects of this complex area of law. Whether advice is required on security of tenure, Section 21 Notices or deposit related issues, the Perrin Myddelton team provide speedy and effective advice in all these areas. Advice is also given where required on the possession of residential premises.' },
      { heading: 'Consumer Protection Legislation and Regulatory Issues', body: 'There are an increasing number of regulations and Consumer Protection legislation affecting Estate Agents, Letting Agents and Managing Agents and we are on hand to provide advice relating to all these issues. Agents have to be very careful in the information that they provide to clients and in the information that they do not provide. Failure to give full disclosure of all circumstances relating to the sale of a property or misdescription can involve both civil and criminal liabilities for the Agent. Our team guide the Agent through this complex legislation to ensure that its interests are fully protected.' }
    ]
  }
];

export const sectors = [
  { name: 'Residential Conveyancing', image: 'https://images.unsplash.com/photo-1609770231080-e321deccc34c?w=720&q=80&auto=format&fit=crop' },
  { name: 'Retail, Hospitality & Leisure', image: 'https://images.unsplash.com/photo-1667388969250-1c7220bf3f37?w=720&q=80&auto=format&fit=crop' },
  { name: 'Social Housing', image: 'https://images.unsplash.com/photo-1621983209348-7b5a63f23866?w=720&q=80&auto=format&fit=crop' },
  { name: 'Construction Services', image: 'https://images.unsplash.com/photo-1535732759880-bbd5c7265e3f?w=720&q=80&auto=format&fit=crop' },
  { name: 'Estate Agents', href: '/services/estate-agents', image: 'https://images.pexels.com/photos/7937763/pexels-photo-7937763.jpeg?w=720&auto=compress&cs=tinysrgb' },
  { name: 'Insurance', image: 'https://images.unsplash.com/photo-1637763723578-79a4ca9225f7?w=720&q=80&auto=format&fit=crop' },
  { name: 'Media & Entertainment', image: 'https://images.pexels.com/photos/7865064/pexels-photo-7865064.jpeg?w=720&auto=compress&cs=tinysrgb' },
  { name: 'Professional Services', image: 'https://images.unsplash.com/photo-1568992687947-868a62a9f521?w=720&q=80&auto=format&fit=crop' },
  { name: 'Property Developers & Investors', image: 'https://images.unsplash.com/photo-1515263487990-61b07816b324?w=720&q=80&auto=format&fit=crop' },
  { name: 'Private Clients & Families', image: 'https://images.unsplash.com/photo-1609220136736-443140cffec6?w=720&q=80&auto=format&fit=crop' }
];

export const testimonials = [
  { quote: 'The Perrin Myddelton team combine solid technical knowledge with a genuinely personable approach. They make complex transactions feel straightforward.', author: 'Housing Association Client' },
  { quote: 'Clear, commercial and always available. Perrin Myddelton have been our trusted advisors for over a decade and continue to deliver.', author: 'Property Developer' },
  { quote: 'Their residential team took the stress out of what could have been a very complicated purchase. Prompt, patient and expert throughout.', author: 'Private Client' },
  { quote: 'We refer clients to Perrin Myddelton with total confidence. Their communication is first class and the feedback we get is uniformly positive.', author: 'Estate Agent Partner' }
];

export const news = [
  { title: 'How might a landlord gain lawful entry for safety inspections?', tag: 'Property', excerpt: 'A brief look at the legal routes landlords can take to secure safe access for essential inspections.' },
  { title: 'Can you sue a careless neighbour for damaging your unique business?', tag: 'Disputes', excerpt: 'When a neighbour\u2019s negligence disrupts a specialist business, the law offers more remedies than you might expect.' },
  { title: 'Protracted disputes with tenants cannot delay structural safety issues', tag: 'Social Housing', excerpt: 'A recent decision reinforces landlords\u2019 duties to prioritise structural safety, even amid ongoing disputes.' },
  { title: "A landlord's right to repair can override a tenant's quiet enjoyment", tag: 'Property', excerpt: 'Balancing repair obligations against tenants\u2019 right to quiet enjoyment: recent guidance from the courts.' }
];

export const aboutContent = {
  title: 'About Us',
  story: {
    heading: 'Our Story as a Law Firm',
    body: [
      'Perrin Myddelton is a well-established law firm based in Harpenden, Hertfordshire (just outside London). Our first-class team of solicitors and other legal and support staff have extensive knowledge and experience in their specialisms so we can offer clients a comprehensive legal service.',
      'Our Perrin Myddelton family are a friendly and approachable team who always put our clients first by providing \u201cExpertise with Care\u201d. We pride ourselves in our ability to be proactive and great communicators in keeping our clients informed throughout their journey.',
      'We are well known for working with over 40 of the largest Housing Associations, which has resulted in Grade 1 status amongst social housing law firms in the Thames Valley Region in the prestigious Chambers and Partners Directory of Law Firm Rankings. In addition, the firm has developed extensive experience in a wide range of other legal areas.'
    ]
  },
  approach: {
    heading: 'The Perrin Myddelton Approach',
    body: [
      'We recognise that clients need a firm which is approachable and accessible; it is a critical part of the value we provide. Our teams come from diverse backgrounds and are always ready to assist our clients. We look to be proactive and creative, and to help our clients throughout the life of projects and cases.',
      'We understand the pressures and constraints that those involved in transactions can often be under, so we excel in helping clients to meet their objectives, and to meet them on time. We will always go the extra mile for clients: our ethos is to provide support whenever needed, for example, to meet tight deadlines.',
      'Our accreditations include Lexcel and the Conveyancing Quality Scheme.'
    ]
  }
};
